import React, { useContext, useState, Fragment } from "react";
import {
  IconButton,
  TableRow,
  TableCell,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { NumericFormat } from "react-number-format";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//Icons
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      onFocus={(e) => e.target.select()}
      // isNumericString
    />
  );
}

export default function ListPayment({
  mainItem,
  subItem,
  requireField,
  setRequireField,
  deletePaymentsList,
  setUpdatePaymentDate,
  setUpdatePaymentMethod,
  setUpdatePaymentPriceKh,
  setUpdatePaymentPriceUsd,
}) {
  const [touched, steTouched] = useState(false);
  const handleTouch = () => steTouched(true);
  let errorMessage = "require!";
  let qtyMessage = ["require!", "bigger than 0!"];

  const ListItems = subItem?.payments?.map((item) => {
    // console.log("sub_item::", item);
    // console.log("mainItem::", mainItem)
    return (
      <TableRow key={item?.key}>
        <TableCell className="disbursement-header-title">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={item?.paymentDate}
              inputFormat="dd-MM-yyyy"
              onChange={(newValue) =>
                setUpdatePaymentDate(
                  mainItem?.key,
                  subItem?.key,
                  item?.key,
                  newValue
                )
              }
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </TableCell>
        <TableCell className="disbursement-header-title">
          <FormControl fullWidth size="small">
            <Select
              value={item?.paymentMethod}
              onChange={(e) =>
                setUpdatePaymentMethod(
                  mainItem?.key,
                  subItem?.key,
                  item?.key,
                  e?.target?.value
                )
              }
            >
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Bank">Bank</MenuItem>
            </Select>
          </FormControl>
        </TableCell>
        <TableCell className="disbursement-header-title">
          <TextField
            fullWidth
            size="small"
            name="NumericFormat"
            id="formatted-numberformat-input"
            onFocus={(e) => e.target.select()}
            InputProps={{
              inputComponent: NumberFormatCustom,
              endAdornment: <InputAdornment position="end">៛</InputAdornment>,
            }}
            value={item?.pricePaidKHR}
            placeholder="exchange rate"
            onChange={(e) => {
              setUpdatePaymentPriceKh(
                mainItem?.key,
                subItem?.key,
                item?.key,
                e?.target.value
              );
            }}
          />
        </TableCell>
        <TableCell className="disbursement-header-title">
          <TextField
            fullWidth
            size="small"
            name="NumericFormat"
            id="formatted-numberformat-input"
            onFocus={(e) => e.target.select()}
            InputProps={{
              inputComponent: NumberFormatCustom,
              endAdornment: <InputAdornment position="end">$</InputAdornment>,
            }}
            value={item?.pricePaidUSD}
            placeholder="price KH"
            onChange={(e) => {
              setUpdatePaymentPriceUsd(
                mainItem?.key,
                subItem?.key,
                item?.key,
                e?.target.value
              );
            }}
          />
        </TableCell>
        <TableCell className="disbursement-header-title" align="right">
          <IconButton
            onClick={() =>
              deletePaymentsList(mainItem?.key, subItem?.key, item?.key)
            }
          >
            <RemoveCircleIcon sx={{ color: "red" }} />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  });

  return <>{ListItems}</>;
}
